import React from 'react';
import styled from 'styled-components';
import { Box, BoxProps } from 'grommet';

const variantStyles = {
  primary: {
    backgroundColor: '#cce5ff',
    borderColor: '#b8daff',
    color: 'black',
  },
  warning: {
    backgroundColor: '#fcf8e3',
    borderColor: '#faebcc',
    color: 'black',
  },
  secondary: {
    backgroundColor: '#fdfcfe',
    borderColor: '#d3d3d3',
    color: 'black',
  },
  info: {
    backgroundColor: '#7db9e8',
    borderColor: '#5a9fcf',
    color: 'black',
  },
  error: {
    backgroundColor: '#f2dede',
    borderColor: '#ebccd1',
    color: 'black',
  },
  success: {
    backgroundColor: '#d4edda',
    borderColor: '#c3e6cb',
    color: 'black',
  },
};

const HighlightStyles = styled.div`
  .alert-highlight {
    padding: 5px;
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.04);
    margin-right: 3px;
    margin-left: 3px;
  }
`;

export const Alert = (
  props: {
    children: React.ReactNode;
    className?: string;
    error?: boolean;
    style?: any;
    variant?: string;
  } & BoxProps
): JSX.Element => {
  const { variant = 'primary', className, children, pad } = props;
  return (
    <Box
      border
      className={className}
      pad={pad || 'medium'}
      round="xsmall"
      variant={variant}
      {...props}
      // @ts-ignore
      style={variantStyles[variant]}
    >
      <HighlightStyles>{children}</HighlightStyles>
    </Box>
  );
};
